<Dialog [show]="showDialog()" (showing)="showDialog.set($event)" #dialog>
  <div stack-layout gap="md">
    <div
      row-layout
      alignItems="center"
      gap="sm"
      justifyContent="space-between"
      paddingLeft="lg"
    >
      <Text display="block" role="headline-large">{{ dialogTitle() }}</Text>
      <button
        icon-button
        variant="ghost"
        symbolName="close"
        (click)="dialog.close()"
      >
        Close
      </button>
    </div>

    <div stack-layout paddingHorizontal="lg" gap="sm">
      <Text color="on-warn-container" role="headline-small">
        The following errors were found in the uploaded file:
      </Text>
      @for (error of errors(); track error) {
        <Text display="block"> {{ error }}<br /> </Text>
      }
    </div>

    <Text color="on-warn-container" align="center">
      (Please address these issues before re-upload)
    </Text>
  </div>
</Dialog>
